/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Of_Contents_TitleInputs */

const sv_table_of_contents_title = /** @type {(inputs: Table_Of_Contents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`På den här sidan`)
};

const en_table_of_contents_title = /** @type {(inputs: Table_Of_Contents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On this page`)
};

/**
* | output |
* | --- |
* | "On this page" |
*
* @param {Table_Of_Contents_TitleInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const table_of_contents_title = /** @type {((inputs?: Table_Of_Contents_TitleInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Of_Contents_TitleInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "sv") return sv_table_of_contents_title(inputs)
	return en_table_of_contents_title(inputs)
});